<template>
    <div class="wrap">
        <div class="content">
            <LuckyWheel 
                ref="myLucky" 
                :class="`myLucky-box ${flag?'apply-shake':''}`" 
                :width="width" 
                :height="height" 
                :prizes="prizes" 
                :blocks="blocks" 
                :buttons="buttons" 
                @start="startCallback" 
                @end="endCallback"
            />

            <button @click="flag = !flag">点击抖动</button>
        </div>
    </div>
</template>
<script>
import { isToday } from '@/utils/common'
import { baseUrls } from '@/utils/baseUrlConfig'
const base_url = baseUrls.user_url
const shop_url = baseUrls.shop_url
const hd_url = 'https://hd.09game.com/turntable/'

export default {
    name: 'demo',
    data() {
        return {
            flag: false,
            width: '6rem',
            height: '6rem',
            blocks: [],
            prizes: [],
            buttons: [],
            btn_lock: false,
        }
    },
    mounted() {},

    created() {
        this.blocks = [
            {
                // padding: '0.46rem',
                imgs: [
                    {
                        src: 'https://img.iwave.net.cn/jeep/51c95637a377c3a12d09abe8b0f975e6.png',
                        width: this.width,
                        height: this.height,
                        rotate: true,
                    },
                ],
            },
        ]

        const prizes = [
            {
                id: 1,
                icon: 'https://img.iwave.net.cn/bmw/b365029b17e0e1fc972b52080f58cc80.png',
                title: 'iphone15 Pro',
            },
            {
                id: 2,
                icon: 'https://img.iwave.net.cn/bmw/bbb9c678305a2f55ce7b285561744596.png',
                title: '普通红包',
            },
            {
                id: 3,
                icon: 'https://img.iwave.net.cn/bmw/9b03fe2dcbb6be8c02ac63ff0927c92f.png',
                title: '5元话费券',
            },
            {
                id: 4,
                icon: 'https://img.iwave.net.cn/bmw/7cffe2c789279a83ef577283535a2c1b.png',
                title: '每日红包',
            },
            {
                id: 5,
                icon: 'https://img.iwave.net.cn/bmw/a3731dd942951974b9be1da171735d82.png',
                title: '幸运红包',
            },
            {
                id: 6,
                icon: 'https://img.iwave.net.cn/bmw/dc3c6e7624f6b8291c82a36b552785f6.png',
                title: '10元话费券',
            },
            {
                id: 7,
                icon: 'https://img.iwave.net.cn/bmw/a6b978fd0064a45ebcd6b649d49714ea.png',
                title: '惊喜福袋',
            },
            {
                id: 8,
                icon: 'https://img.iwave.net.cn/bmw/873a940855c837b4d6622fe8da442b8b.png',
                title: '谢谢参与',
            },
        ]
        this.prizes = prizes.map((item) => ({
            fonts: [
                {
                    text: item.title,
                    top: '25%',
                    fontColor: '#FF7002',
                    fontSize: '0.35rem',
                    fontWeight: 600,
                    wordWrap: false,
                    lineHeight: '0.35rem',
                },
            ],
            imgs: [{ src: item.icon, top: '0.7rem', width: '1.3rem', height: '1.4rem' }],
        }))

        this.buttons = [
            {
                radius: '32.8%',
                imgs: [
                    {
                        src: 'https://img.iwave.net.cn/jeep/8e38bb871f79ef8950da8697603cde94.png',
                        top: '-1rem',
                        width: '2rem',
                        height: '2rem',
                    },
                ],
            },
        ]
    },
    methods: {
        startCallback() {
            if(this.btn_lock ) {
                return false
            }
            this.btn_lock = true;
            console.log('#@@@@@')
            // 调用抽奖组件的play方法开始游戏
            this.$refs.myLucky.play()
            // 模拟调用接口异步抽奖
            setTimeout(() => {
                // 假设后端返回的中奖索引是0
                const index = 0
                // 调用stop停止旋转并传递中奖索引
                this.$refs.myLucky.stop(index)
            }, 3000)
        },
        // 抽奖结束会触发end回调
        endCallback(prize) {
            console.log(JSON.stringify(prize));
            alert(`恭喜获得：${prize.fonts[0].text}`)
            this.btn_lock = false;
        },
    },
}
</script>

<style lang="scss" scoped>
.wrap{
    .myLucky-box{
        margin: 0 auto;
    }
}

 .apply-shake {

            animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;

        } 
    @keyframes shake {
        0% { transform: translate(0, 0); }
        10% { transform: translate(-10px, 0); }
        20% { transform: translate(10px, 0); }
        30% { transform: translate(-10px, 0); }
        40% { transform: translate(10px, 0); }
        50% { transform: translate(-10px, 0); }
        60% { transform: translate(10px, 0); }
        70% { transform: translate(-10px, 0); }
        80% { transform: translate(10px, 0); }
        90% { transform: translate(-10px, 0); }
        100% { transform: translate(0, 0); }
    }
 
</style>




// WEBPACK FOOTER //
// src/view/demo.vue